import React, { Component } from "react"

/* Constants */
import { env, utils } from "../constants"

/* REST API */
import { members, worktimes, create, checkPhone } from "../api/Organization"

/* Component */
import { Avatar, Button, Loading, Success } from "../components"

/* Icons */
import { StarFilled } from "@ant-design/icons"


class Members extends Component {
    constructor() {
        super()
        this.state = {
            loading: false,
            data: null,
            memberID: 0,

            member: null,

            day: null,
            time: null,

            visible: null,
            phone: "+ 7",
            name: "",

            waiting: false,

            status: null,

            dbUser: null,
            isDbUser: null,

            userLoading: false
        }
    }

    componentDidMount = () => {
        this.load()
    }

    load = () => {
        const { organizationID, serviceID } = this.props

        /* Check Fields */
        if (!utils.isEmpty(organizationID) || !utils.isEmpty(serviceID)) {
            this.setState({ status: "network" })
            return
        }

        /* Send to REST API */
        members({ id: organizationID, serviceID }).then(response => {
            if (response.status === 200) {
                this.setState({ data: response.data, loading: false })
                setTimeout(() => {
                    this.worktimes()
                }, 200)
            }
            else {
                this.setState({ data: null, status: "error", loading: false })
            }
        }).catch(() => {
            this.setState({ data: null, status: "network", loading: false })
        })
    }

    /* Load Work Times */
    worktimes = (index = 0) => {

        /* Fields */
        const { memberID, data } = this.state
        const { organizationID } = this.props

        /* Start loading */
        this.setState({ waiting: true, day: null, time: null })

        /* Scroll to center */
        if (this._scroll && this._scroll.current) {
            this._scroll.current.scrollIntoView({ behavior: 'smooth' })
        }

        /* Send to REST API */
        worktimes({ id: memberID, organizationID }).then(response => {
            if (response.status === 200) {
                const member = response.data
                this.setState({ member, waiting: false })
                this.setDefaultDate(member.worktimes, data.service.sessionTime, member.bookings)
            } else {
                this.setState({ waiting: false })
            }
        })

    }

    /* Check phone exists */
    checkUserPhone = (phone) => {

        const { dbUser } = this.state

        this.setState({ userLoading: true })

        checkPhone({ phone }).then(response => {

            if (response.status === 200) {
                if (!response.data) {
                    this.setState({ dbUser: null, isDbUser: null })
                } else {
                    if (!dbUser || (dbUser && dbUser.id !== response.data)) {
                        this.setState({ dbUser: response.data, isDbUser: null })
                    }
                }
                this.setState({ userLoading: false })
            }
            else {
                this.setState({ userLoading: false })
                utils.toggleError("Что-то пошло не так! Попробуйте позднее.", "error", "error")
            }
        }).catch(() => {
            this.setState({ userLoading: false })
            utils.toggleError("Что-то пошло не так! Попробуйте позднее.", "error", "error")
        })
    }


    /* Book */
    book = () => {
        /* Fields */
        const { organizationID, serviceID } = this.props
        const { data, member, day, time, phone, name, dbUser, isDbUser } = this.state

        /* Date Fields */
        const date = new Date(day.date)

        const timeList = time.startTime.split(":")

        if (timeList.length > 1) {
            const hour = parseInt(timeList[0])
            const minute = parseInt(timeList[1])
            date.setHours(hour)
            date.setMinutes(minute)
        }

        const body = {
            userID: isDbUser && dbUser ? dbUser.id : null,
            phone, name,
            organizationID,
            memberID: member.id,
            serviceID,
            total: data.service.price,
            endTotal: data.service.endPrice,
            reservedTime: date,
            sessionTime: data.service.sessionTime
        }

        create(body).then(response => {

            if (response.status === 200) {
                this.setState({ status: "ok" })
            }
            else {
                utils.toggleError("Что-то пошло не так! Попробуйте позднее.", "error", "error")
            }
        }).catch(() => {
            utils.toggleError("Что-то пошло не так! Попробуйте позднее.", "error", "error")
        })

    }

    /* Set Default Date */
    setDefaultDate = (worktimes, sessionTime, bookings) => {

        const days = utils.weekDays(worktimes, sessionTime)

        if (days.length > 0) {

            let _day = null
            let _time = null

            days.forEach((day, i) => {

                if (_day !== null) {
                    return false
                }

                const times = utils.times(day.startTime, day.endTime, sessionTime, day)

                if (times.length > 0) {

                    times.forEach((time, index) => {

                        if (_time !== null) {
                            return false
                        }

                        if (!utils.checkTime(day, time.startTime, bookings)) {
                            _time = times[index]
                            _day = days[i]
                        }
                    })

                }
            })

            this.setState({ day: _day, time: _time })
        }
    }


    /* Draw Slots */
    _slots = () => {

        /* Fields */
        const { member, data, day, time, loading } = this.state

        if (loading) {
            return <Loading />
        }

        if (!data || !member || !day) {
            return
        }

        const days = utils.weekDays(member.worktimes, data.service.sessionTime)
        const times = day ? utils.times(day.startTime, day.endTime, data.service.sessionTime, day) : []

        /* Check Members */
        if (data.members && Array.isArray(data.members)) {
            return (
                <div className="slots-list">
                    <div className="days-list">
                        {
                            days.map((item, index) => {
                                return (
                                    <div onClick={() => this.setDate(item, index)} className={`day ${day && parseInt(day.number) === parseInt(item.number) ? "selected" : ""}`} key={`day-${index}`}>
                                        <p>{item.weekday.text}</p>
                                        <p className="bold">{item.day}</p>
                                        <p>{item.month}</p>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <p className="time-title">Выберите время</p>

                    <div className="time-list">
                        {times.map((item, index) => {

                            const reserved = utils.checkTime(day, item.startTime, member.bookings)

                            let style = ""

                            if (time && time.startTime === item.startTime) {
                                style = "selected"
                            }

                            if ((index + 1) % 3 === 1 || (index + 1) % 3 === 2) {
                                style += " mr10"
                            }

                            return (
                                <div onClick={() => !reserved && this.setState({ time: item })} className={`time ${reserved ? "reserved" : ""} ${style}`} key={`time-${index}`}>
                                    <p color="#999" size={13}>{item.startTime} - {item.endTime}</p>
                                </div>
                            )

                        })}
                    </div>

                </div>
            )
        }
    }

    /* Draw Members */
    _members = () => {

        /* Fields */
        const { data, memberID } = this.state

        /* Check Members */
        if (data.members && Array.isArray(data.members)) {

            const defaultMember = [{ id: 0, name: "Любой специалист", image: null, rating: data.rating, reviews: data.reviews }]
            const members = [...defaultMember, ...data.members]

            return (
                <div className="members-list" ref={ref => this._scroll = ref}>

                    {
                        members.map((item, index) => {
                            const uri = item.image ? `${env.point}/members/${item.image}` : '/images/profile-filled.png'
                            const isMember = memberID === item.id

                            return (
                                <div className={`member ${isMember ? "selected" : ""}`} key={`ava-${index}`} onClick={() => this.setState({ memberID: item.id }, () => this.worktimes(index))}>

                                    <Avatar uri={item.image} />

                                    <p className="username">{item.name}</p>

                                    <div className="row">
                                        <StarFilled style={{ fontSize: '16px', color: '#ff9800' }} />
                                        <p className="bold">{Number(data.rating).toFixed(2)}</p>
                                        {parseInt(data.reviews) > 0 && <p>({data.reviews})</p>}
                                    </div>

                                    {memberID === item.id &&
                                        <div className="member-check">
                                            <img src="/images/check.png" alt="member" />
                                        </div>
                                    }

                                </div>
                            )
                        })
                    }
                </div>
            )
        }
    }


    /* Set Date */
    setDate = (day, index) => {

        /* Fields */
        const { data, member } = this.state

        /* Save */
        this.setState({ day })

        /* Scroll to center */
        if (this._days) {
            this._days.scrollToIndex({ index, animated: true, viewPosition: 0.5 })
        }

        /* Time fields */
        let _time = null

        /* Get times */
        const times = utils.times(day.startTime, day.endTime, data.service.sessionTime, day)

        if (times.length > 0) {
            times.forEach((time, index) => {

                if (_time !== null) {
                    return false
                }

                if (!utils.checkTime(day, time.startTime, member.bookings)) {
                    _time = times[index]
                }
            })
        }

        if (_time) {
            this.setState({ time: _time })
        }

    }

    bookCheck = () => {
        this.setState({ visible: true })
    }

    setPhone = (event) => {

        event.preventDefault()

        const { userLoading, phone } = this.state

        let value = event.target.value.replace(/\D/g, '');

        let formattedValue = ''

        if (value.length > 0) {
            formattedValue += '+' + value.substring(0, 1)
        }
        if (value.length >= 2) {
            formattedValue += ' (' + value.substring(1, 4)
        }
        if (value.length >= 5) {
            formattedValue += ') ' + value.substring(4, 7)
        }

        if (value.length >= 8) {
            formattedValue += '-' + value.substring(7, 9)
        }

        if (value.length >= 10) {
            formattedValue += '-' + value.substring(9, 11)
        }

        // +7 (747) 599-40-41

        const tempPhone = formattedValue

        if (phone !== tempPhone) {
            this.setState({ dbUser: null, isDbUser: null })
        }

        console.log(tempPhone.length === 18 && !userLoading && phone.replace(/\D/g, '').length !== 18)

        if (tempPhone.length === 18 && !userLoading && phone.replace(/\D/g, '').length !== 18) {
            this.checkUserPhone(tempPhone)
        }

        this.setState({ phone: tempPhone })
    }

    _bookModal = () => {

        const { visible, phone, name, dbUser, isDbUser } = this.state

        const dbUserCheck = dbUser && isDbUser === null

        return (
            <div className={`bookModal-back ${visible ? "visible" : ""}`}>
                <div className="bookModal-backdrop" onClick={() => this.setState({ visible: false })} />
                <div className="bookModal-content">
                    <p className="title">Введите ваши данные для подтверждения записи</p>
                    <input className="phone" value={phone} onChange={event => this.setPhone(event)} placeholder="Введите номер телефона" maxlength="18" />

                    {
                        dbUserCheck ?
                            <div className="db-user">
                                <p>Вы {dbUser.name} ?</p>
                                <div className="db-user-buttons">
                                    <div className="btn red" onClick={() => this.setState({ isDbUser: false })}>НЕТ</div>
                                    <div className="btn green" onClick={() => this.setState({ isDbUser: true, name: dbUser.name })}>ДА</div>
                                </div>
                            </div>
                            : null
                    }

                    {!dbUserCheck ? <input className="name" value={name} onChange={event => this.setState({ name: event.target.value })} placeholder="Введите свое имя" /> : null}

                    <Button modal={true} text="Отправить" onClick={() => this.book()} />
                </div>
            </div>
        )

    }


    render = () => {

        const { data, visible, status } = this.state

        if (!data) {
            return <Loading />
        }

        if (status === "ok") {
            return (
                <div className="members">
                    <div className="success-block">
                        <Success />
                        <p>Запись успешно создана, мы перезвоним вам в ближайшее время</p>
                    </div>
                </div>
            )
        }

        return (
            <div className="members">
                <div className="members-head">
                    <div className="name">
                        <p className="or-name">{data.name}</p>
                    </div>
                    <div className="members-location">
                        <span>Адрес</span>
                        <p>{data.address}</p>
                    </div>

                    <div className="members-bottom-border" />

                    <div className="members-service">
                        <span>{data.service.name}</span>
                        <div className="members-service-price">
                            <p>{utils.convertor(data.service.price)}</p>
                            <p>{utils.checkValue(data.service.endPrice, null) && " - "}{utils.convertor(utils.checkValue(data.service.endPrice, null))}</p>
                            <p className="dot">{utils.checkValue(data.service.sessionTime, null) && "•"}</p>
                            <p>{utils.timeConvertor(utils.checkValue(data.service.sessionTime, null))}</p>
                        </div>
                    </div>
                </div>

                <div className="members-box">
                    <p className="title">Выберите специалиста</p>
                    {this._members()}
                </div>

                <div className="members-date-box">
                    <p className="title">Выберите дату</p>
                    {this._slots()}
                </div>

                {this._bookModal()}

                {
                    !visible ?
                        <div className="bottom-button">
                            <Button text="Записаться" onClick={() => this.bookCheck()} />
                        </div>
                        : null
                }

            </div>
        )

    }

}

export default Members